import { h } from 'preact'
import { memo } from 'preact/compat'
import PropTypes from 'prop-types'
import Input from '../../Common/Input'
import { useTranslations } from '../../../hooks/useTranslations'

const AddressField = ({
  register,
  errors,
  setValue,
  field,
}) => {
  const l10n = useTranslations()

  const reset = () => setValue(field.name, '', { shouldValidate: true })

  return (
    <Input
      label={field.title}
      inputProps={{
        'data-testid': 'field-input',
        name: field.name,
        id: field.name,
        autocomplete: field.autocomplete,
        ...register(field.name, { required: field.required }),
      }}
      reset={reset}
      hasError={Boolean(errors[field.name])}
      errorMessage={field.errorMessage || l10n.t('This field is required')}
    />
  )
}

AddressField.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  field: PropTypes.exact({
    name: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    autocomplete: PropTypes.string,
    available: PropTypes.bool,
    errorMessage: PropTypes.string,
  }),
}

export default memo(AddressField)
